import React from 'react';
import ReactDOM from 'react-dom/client';
import App from '@app/App';
import '@app/index.css';
import { version } from 'package.json';
import { sessionTracker, AnalyticsService } from '@app/shared/services/analytics.service';
import { getDeviceId } from '@app/shared/utils/device-id';
import { passiveCollector } from '@app/shared/services/passive-data/passive-data-collector';

// import * as Sentry from '@sentry/react';

// VitePWA handles service worker registration automatically
// Manual registration removed to prevent conflicts

// Sentry.init({
// 	dsn: 'https://4802d1c5829f416791eb7ff875203e55@o4505494863216640.ingest.us.sentry.io/4505494878158848',
// 	integrations: [
// 		new Sentry.BrowserTracing({
// 			// Set `tracePropagationTargets` to control for which URLs distributed tracing should be enabled
// 			tracePropagationTargets: ['localhost', /^https:\/\/yourserver\.io\/api/],
// 		}),
// 		new Sentry.Replay(),
// 	],
// 	// Performance Monitoring
// 	tracesSampleRate: 1.0, // Capture 100% of the transactions, reduce in production!
// 	// Session Replay
// 	replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
// 	replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
// });

// Initialize Analytics - Use uID from credentials or URL, fall back to device UUID
function resolveUserId(): string {
  try {
    const { uID } = JSON.parse(localStorage.getItem('credential_items') || '{}');
    if (uID) return uID;
  } catch { /* ignore */ }

  const urlParams = new URLSearchParams(window.location.search);
  const urlUid = urlParams.get('uID');
  if (urlUid) return urlUid;

  return getDeviceId();
}

const userId = resolveUserId();
AnalyticsService.setUser(userId);

// Start session duration tracking
sessionTracker.start();

// Start passive data collection
passiveCollector.startSession(userId);

// Patch removeChild to handle Leaflet/React DOM conflict.
// Leaflet manipulates DOM nodes that React also tracks. During unmount,
// React calls parent.removeChild(child) but Leaflet already removed the child.
// This patch returns the child silently instead of crashing.
const origRemoveChild = Node.prototype.removeChild;
Node.prototype.removeChild = function <T extends Node>(child: T): T {
	if (child.parentNode !== this) {
		return child;
	}
	return origRemoveChild.call(this, child) as T;
};

ReactDOM.createRoot(document.getElementById('root') as HTMLElement).render(
	<App />
);
